import { createTypes } from 'redux-create-types';
import { fromType, } from 'kreighter';

const namespace = 'discussion';

export const discussionActions = createTypes([
    'saveDiscussion',
    'removeDiscussion',
    'increasePostCount',
    'decreasePostCount'
], namespace);

export const discussionActionsCreators = {
    saveDiscussion: fromType(discussionActions.saveDiscussion, ['discussion', 'topicId']),
    removeDiscussion: fromType(discussionActions.removeDiscussion, ['id']),
    increasePostCount: fromType(discussionActions.increasePostCount, ['id']),
    decreasePostCount: fromType(discussionActions.decreasePostCount, ['id']),
}